import { LivePreviewSidebar } from "./LivePreviewSidebar";

interface DesktopSidebarProps {
    activeTemplateId: string | null;
    setActiveTemplateId: (id: string | null) => void;
}

export const DesktopSidebar = ({
    activeTemplateId,
    setActiveTemplateId,
}: DesktopSidebarProps) => {
    return (
        <div className="mt-14 hidden border-r border-neutral-200 lg:fixed lg:inset-y-0 lg:z-10 lg:flex lg:w-72 lg:flex-col lg:pt-2">
            <LivePreviewSidebar
                activeTemplateId={activeTemplateId}
                setActiveTemplateId={setActiveTemplateId}
            />
        </div>
    );
};
